const activeCountries = [
  { code: "it", defaultLanguage: "it", name: "Italia", flag: "" },
  { code: "es", defaultLanguage: "es", name: "España", flag: "" },
];

export default activeCountries;
